import { Injectable, inject, Injector } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { filter, first, tap } from 'rxjs/operators';
import { select, Store } from '@ngxs/store';
import { UserState } from './state/user.state';
import { LoadUserOptions } from './state/user.actions';

@Injectable()
export class UserOptionsResolver {
  private readonly injector = inject(Injector);

  private readonly userOptionsLoadedSignal = select(UserState.userOptionsLoaded);

  readonly userOptionsLoaded$: Observable<boolean> = toObservable(this.userOptionsLoadedSignal, {
    injector: this.injector,
  });

  constructor(private store: Store) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.userOptionsLoaded$.pipe(
      tap((userOptionsLoaded) => {
        if (!userOptionsLoaded) {
          this.store.dispatch(new LoadUserOptions());
        }
      }),
      filter((userOptionsLoaded) => userOptionsLoaded),
      first()
    );
  }
}
